/**
 * Chailease.SystemManagement.API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface SCCLMappingViewModel { 
    baclmappingId?: number;
    mapSalesDeptId?: number;
    readonly mapsalesdepartmentId?: number;
    mapsalesdepartmentCode?: string;
    mapsalesdepartmentName?: string;
    mapsalesdepartmentLevel?: number;
    mapsalescompanyId?: number;
    mapsalesParentDepartmentId?: number;
    mapsalesworkType?: number;
    mapCrdDeptId?: number;
    readonly mapcrddepartmentId?: number;
    mapcrddepartmentCode?: string;
    mapcrddepartmentName?: string;
    mapcrddepartmentLevel?: number;
    mapcrdcompanyId?: number;
    mapcrdParentDepartmentId?: number;
    mapcrdworkType?: number;
    mapCsDeptId?: number;
    readonly mapcsdepartmentId?: number;
    mapcsdepartmentCode?: string;
    mapcsdepartmentName?: string;
    mapcsdepartmentLevel?: number;
    mapcscompanyId?: number;
    mapcsParentDepartmentId?: number;
    mapcsworkType?: number;
    mapLawDeptId?: number;
    readonly maplawdepartmentId?: number;
    maplawdepartmentCode?: string;
    maplawdepartmentName?: string;
    maplawdepartmentLevel?: number;
    maplawcompanyId?: number;
    maplawworkType?: number;
    maplawParentDepartmentId?: number;
}